export const headerDataFr = {
    headerCollection: {
        items: [
            {
                leftCollection: {
                    items: [
                        {
                            sys: {
                                id: '3Ar43vJ1kCyxBFdS4kK6dU'
                            },
                            __typename: 'List',
                            name: null,
                            heading: 'Tout voir',
                            itemsCollection: {
                                items: [
                                    {
                                        sys: {
                                            id: '1q4gYgYZOVrODuFPAP4bp3'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Maquillage',
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: '25gscNnavP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Le Visage',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDm2Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Base pour le visage',
                                                                url: '/category/fa_primer',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5CA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Fond de teint',
                                                                url: '/category/foundation',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WhbbbODVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Crème teintée',
                                                                url: '/category/tint_moist',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVskmk1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Couleur correctrice',
                                                                url: '/category/concealer',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVmmns1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Poudre',
                                                                url: '/category/powder',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVsbbj1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Poudre et vaporisateur de fixation',
                                                                url: '/category/setting_sp',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DnnLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Fard à joues',
                                                                url: '/category/blush',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVskn1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Enlumineur',
                                                                url: '/category/highlightr',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DnkLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Poudre bronzante',
                                                                url: '/category/bronzer',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DLHzmmlkVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Outils & Accessoires',
                                                                url: '/category/fa_tools',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVnsknk1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Applicateur pour le visage',
                                                                url: '/category/fa_applic',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WvvhODVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tout le visage',
                                                                url: '/category/mkp_total_face',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscjkiNnavP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Les Yeux',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAbhJbDm2Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Sourcils',
                                                                url: '/category/eye_brow',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFnhvhkvC5CA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Base pour les yeux',
                                                                url: '/category/eye_primer',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1Wbnh1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Fard à paupières',
                                                                url: '/category/eye_shadow',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1bhvhvkhDLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Crayon pour les yeux / Liner',
                                                                url: '/category/eye_liner',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1mjWODVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Rimmel',
                                                                url: '/category/mascara',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1mknkkWODVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Faux cils',
                                                                url: '/search?q=lash',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WOnkklnlkDVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Outils & Accessoires',
                                                                url: '/category/eye_tools',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVsnknk1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Applicateur',
                                                                url: '/category/eye_applic',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WObjjVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Autre',
                                                                url: '/category/mkp_total_eye',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNnavPml4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Les Lèvres',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDm2Zrj9cxdknnUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Base pour les lèvres',
                                                                url: '/category/lip_primer',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5CA7nnSfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Couleur de lèvres',
                                                                url: '/category/lip_color',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODm1Vs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Gloss',
                                                                url: '/category/lip_gloss',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVm2s1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Crayon à lèvres',
                                                                url: '/category/lip_liner',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1m3DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Outils & Accessoires',
                                                                url: '/category/lip_tools',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVm4s1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Applicateur pour les lèvres',
                                                                url: '/category/lip_applic',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVsm51DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Toutes les lèvres',
                                                                url: '/category/mkp_total_lip',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNnavP4m6xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Les Ongles',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDm2m7Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soin des ongles',
                                                                url: '/category/nail_care',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5CA7Sm8fF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Base & Top Coat',
                                                                url: '/category/nail_care',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DLHm9zVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Couleur des ongles',
                                                                url: '/category/clr_enamel',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: '1WODVs1Dm1oLHzVhbN7ImBlIp'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Outils & Accessoires pour les ongles',
                                                            //     url: '/category/nail_tools',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: 'allNails'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les ongles',
                                                                url: '/category/mkp_total_nail',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNnavP4xm11lztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Outils de maquillage',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDm12m2Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Pinceaux & Applicateur',
                                                                url: '/category/oth_face',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5CAm237SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Accessoires',
                                                                url: '/category/all_other',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: '1WODm123Vs1DLHzVhbN7ImBlIp'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Applicateurs',
                                                            //     url: '/category/oth_applic',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: '1WOm16DVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Outils & Accessoires',
                                                                url: '/category/oth_tools',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'makeUpToolsFrench'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les outils de maquillage',
                                                                url: '/category/oth_tools',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNnam17vP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Coffrets de maquillage',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJm18bDm2Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Coffrets de maquillage',
                                                                url: '/category/set',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'setFrench'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les ensembles de maquillage',
                                                                url: '/category/set',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'shopAllMakeup'
                                                    },
                                                    __typename: 'Link',
                                                    name: null,
                                                    text: 'Tout Maquillage',
                                                    url: '/category/makeup',
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        sys: {
                                            id: '3mKyh7v1eerm19JtsbBzl6J97'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Soins pour la peau',
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: '25gscNm20navP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Le Visage',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDm2m21Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Nettoyants',
                                                                url: '/category/fa_clnsr',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5CAm227SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soins',
                                                                url: '/category/fa_serum',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1Dm23LHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Yeux',
                                                                url: '/category/eye_trtmnt',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1Dm234LHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Masque pour les yeux & le visage',
                                                                url: '/category/s_mask',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DLHm234zVhbN7ImBlIp1'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Hydratants',
                                                                url: '/category/fa_cream',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1rg1WODVs1DLHzVhbN7ImBlIp00'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tout le visage',
                                                                url: '/category/skin_total_face',

                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                // {
                                                //     sys: {
                                                //         id: '25gscNnam26vP4xlztprPLUhG'
                                                //     },
                                                //     __typename: 'List',
                                                //     name: null,
                                                //     heading:
                                                //         'Soins pour Hommes',
                                                //     itemsCollection: {
                                                //         items: [
                                                //             {
                                                //                 sys: {
                                                //                     id: '6TAJbDm2m27Zrj9cxdUSImfse'
                                                //                 },
                                                //                 __typename:
                                                //                     'Link',
                                                //                 text: 'Soins pour Hommes',
                                                //                 url: '/',
                                                //                 externalUrl:
                                                //                     null,
                                                //                 openLinkInNewTab: false,
                                                //                 iconName: null,
                                                //                 theme: null,
                                                //                 type: 'unstyled',
                                                //                 isExternal: false
                                                //             }
                                                //         ]
                                                //     }
                                                // },
                                                {
                                                    sys: {
                                                        id: '25gm28scNnavP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Soins du corps',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDmm292Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Nettoyant pour le corps',
                                                                url: '/category/s_oth_body',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFm30C5CA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soin du corps',
                                                                url: '/category/bo_serum',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODm32Vs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Hydratant pour le corps',
                                                                url: '/category/bo_crm_ltn',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODm31Vs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Savon pour les mains',
                                                                url: '/category/hand_soap',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WOm33DVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Déodorant & Antisudorifique',
                                                                url: '/category/s_deo',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1nmWODVs1DLHzVhbN7ImBlIpfhd'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soins du corps',
                                                                url: '/category/skin_total_body',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNn1navP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Protection solaire',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAn2JbDm2Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Crème solaire pour le visage',
                                                                url: '/category/fa_in_sun',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5n3CA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Crème solaire pour le corps',
                                                                url: '/category/bo_in_sun',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WOn4DVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Après-soleil',
                                                                url: '/category/after_sun',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WOn6DVs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Autobronzant',
                                                                url: '/category/s_tanner',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1DLHzVhbN7IggmBlIp21'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soins Solaires Spf Tous',
                                                                url: '/category/skin_total_sun',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNnn8avP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Outils de soins de la peau',
                                                    itemsCollection: {
                                                        items: [
                                                            // {
                                                            //     sys: {
                                                            //         id: '6TAJbDmn92Zrj9cxdUSImfse'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Outils pour le visage',
                                                            //     url: '/',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            // {
                                                            //     sys: {
                                                            //         id: '1AFC5n10CA7SfF41rVexinsxM'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Outils pour le corps',
                                                            //     url: '/',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: '1AFC5bvnCA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Outils de soins de la peau',
                                                                url: '/category/skin_sets___kits',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: '25gscNl1navP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Ensembles de soins de la peau',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDml22Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Ensembles de soins de la peau',
                                                                url: '/category/sets_kits',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDmbnv2Zfrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les coffrets de soins',
                                                                url: '/category/skin_sets___kits',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'shopAllSkincare'
                                                    },
                                                    __typename: 'Link',
                                                    name: null,
                                                    text: 'Tous les soins pour la peau',
                                                    url: '/category/skincare',
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        sys: {
                                            id: 'PKQeaNzSfa5TaGNlZvg35'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Parfums',
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: '25gsl34cNnavP4xlztprPLUhG'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Parfums',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: '6TAJbDml782Zrj9cxdUSImfse'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Eau de Toilette',
                                                                url: '/category/edt',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1AFCl905CA7SfF41rVexinsxM'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Eau de Parfum',
                                                                url: '/category/edp',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVs1Dk1LHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Parfum',
                                                                url: '/category/perfume',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODk2Vs1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Eau de Cologne',
                                                                url: '/search?q=cologne',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVk3s1DLHzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Solide & Innovant',
                                                                url: '/category/oth_juic',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: '1WODVsbbfj1DLHggzVhbN7ImBlIp'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les parfums',
                                                                url: '/category/frag_ancillaries',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'homeAndLifestyleCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Maison & Style de vie',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'homeAndLifestyleCandles'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Bougies',
                                                                url: '/category/candles',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'homeAndLifestyleDiffusers'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Diffuseurs pour la maison',
                                                                url: '/category/diffusers',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: 'homeAndLifestyleCarDiffuser'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Diffuseur pour voiture',
                                                            //     url: '/category/home_sets',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: 'homeAndLifestyleRoomFresheners'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Désodorisants & Accessoires',
                                                                url: '/category/diffusers',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'homeAndLifestyleRoomFresheners'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tout Maison et style de vie',
                                                                url: '/category/frag_home_scents',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'bathAndBodyCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Bain & Corps',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'bathAndBodyBodyCleanser'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Nettoyant pour le corps',
                                                                url: '/category/f_oth_body',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'bathAndBodyBodyLotion'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Lotion pour le corps',
                                                                url: '/category/body_oil',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'bathAndBodyBodyMist'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Brume pour le corps',
                                                                url: '/category/body_spray',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'bathAndBodyHairMist'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Brume pour les cheveux',
                                                                url: '/category/hair',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: 'bathAndBodyForTheBath'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Pour le bain',
                                                            //     url: '/category/buble_bath',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: 'bathAndBodyDeodorant'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Déodorant',
                                                                url: '/category/f_deo',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: 'bathAndBodyGrooming'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Soins personnels',
                                                            //     url: '/category/shave',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: 'allBathAndBody'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tout le bain et le corps',
                                                                url: '/category/frag_total_juices',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'fragranceSetsCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Coffrets de parfums',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'fragranceSets'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Coffrets de parfums',
                                                                url: '/category/oth_sets',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'fragranceSetsAll'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les coffrets de parfums',
                                                                url: '/category/frag_gift_sets',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'shopAllFragrance'
                                                    },
                                                    __typename: 'Link',
                                                    name: null,
                                                    text: 'Tous les parfums',
                                                    url: '/category/fragrances',
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        sys: {
                                            id: '2YHIActKx8AVKtY8mA4CcM'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Cheveux',
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: 'customerFacingCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Shampooing & Après-shampooing',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'customerFacingShampoo'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Shampooing',
                                                                url: '/category/daily_sham',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'customerFacingConditioner'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Après-shampooing',
                                                                url: '/category/daily_cond',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'hairCareAll'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les soins capillaires',
                                                                url: '/category/hair_care',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'treatmentCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Traitement',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'treatmentHairMask'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Masque capillaire',
                                                                url: '/category/h_mask',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'treatmentHairColor'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Coloration des cheveux',
                                                                url: '/category/color',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'treatmentScalpCare'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soin du cuir chevelu',
                                                                url: '/category/oth_care',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'stylingCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Produits de coiffage',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'stylingHairStyling'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Fixatif capillaire',
                                                                url: '/category/oth_styl',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'stylingHairStylingSpray'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Spray coiffant',
                                                                url: '/category/spray',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'stylingMousseFoam'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Mousse coiffante',
                                                                url: '/category/mousse',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            // {
                                                            //     sys: {
                                                            //         id: 'stylingDryShampoo'
                                                            //     },
                                                            //     __typename:
                                                            //         'Link',
                                                            //     text: 'Shampooing sec',
                                                            //     url: '/category/dry_sham',
                                                            //     externalUrl:
                                                            //         null,
                                                            //     openLinkInNewTab: false,
                                                            //     iconName: null,
                                                            //     theme: null,
                                                            //     type: 'unstyled',
                                                            //     isExternal: false
                                                            // },
                                                            {
                                                                sys: {
                                                                    id: 'AllHairStyling'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Toutes les coiffures',
                                                                url: '/category/hair_styling',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'hairSetsCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Coffrets pour cheveux',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'hairSets'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Coffrets pour cheveux',
                                                                url: '/category/sets',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'hairSets'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les ensembles de maquillage',
                                                                url: '/category/mkp_total_sets',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'allHairSets'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Tous les ensembles de cheveux',
                                                                url: '/category/hair_sets',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'shopAllHair'
                                                    },
                                                    __typename: 'Link',
                                                    name: null,
                                                    text: 'Tout Parfums',
                                                    url: '/category/hair',
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                }
                                            ]
                                        }
                                    },

                                    {
                                        sys: {
                                            id: 'brands'
                                        },
                                        __typename: 'Link',
                                        name: null,
                                        text: 'Marques',
                                        url: '/pages/brands',
                                        openLinkInNewTab: false,
                                        iconName: null,
                                        theme: null,
                                        type: 'unstyled',
                                        isExternal: false
                                    },
                                    {
                                        sys: {
                                            id: '1NaEeldvjCHUOVfJAIrnGo'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Bien-être (à venir)',
                                        isDisabled: true,
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: 'supplementsAndBeveragesCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Compléments alimentaires & Boissons',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'supplements'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Compléments alimentaires',
                                                                url: '/category/supp_teas',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'Vitamines'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Vitamins',
                                                                url: '/category/supp_vit',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'Collagène'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Collagen',
                                                                url: '/category/supp_coll',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'functionalMushrooms'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Champignons fonctionnels',
                                                                url: '/category/supp_mush',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'sexualWellnessCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading: 'Bien-être sexuel',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'vibratorsToys'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Vibromasseurs & Jouets',
                                                                url: '/category/sw_men_t',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            },
                                                            {
                                                                sys: {
                                                                    id: 'lubricant'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Lubrifiant',
                                                                url: '/category/sw_lub',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                },
                                                {
                                                    sys: {
                                                        id: 'oralCareCategory'
                                                    },
                                                    __typename: 'List',
                                                    name: null,
                                                    heading:
                                                        'Soin bucco-dentaire',
                                                    itemsCollection: {
                                                        items: [
                                                            {
                                                                sys: {
                                                                    id: 'oralCare'
                                                                },
                                                                __typename:
                                                                    'Link',
                                                                text: 'Soin bucco-dentaire',
                                                                url: '/category/toothbrush',
                                                                externalUrl:
                                                                    null,
                                                                openLinkInNewTab: false,
                                                                iconName: null,
                                                                theme: null,
                                                                type: 'unstyled',
                                                                isExternal: false
                                                            }
                                                        ]
                                                    }
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        sys: {
                                            id: '1bbNaEeldvjCHUOVfJAIrnGo'
                                        },
                                        __typename: 'List',
                                        name: null,
                                        heading: 'Et Tout le Reste',
                                        isDisabled: true,
                                        itemsCollection: {
                                            items: [
                                                {
                                                    sys: {
                                                        id: 'restOfItItems1'
                                                    },
                                                    __typename: 'Link',
                                                    text: 'Hydratation',
                                                    url: '/',
                                                    externalUrl:
                                                        'https://rennai.com',
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                },
                                                {
                                                    sys: {
                                                        id: 'restOfItItems2'
                                                    },
                                                    __typename: 'Link',
                                                    text: 'Nouveauté',
                                                    url: '/category/nov_accessories',
                                                    externalUrl: null,
                                                    openLinkInNewTab: false,
                                                    iconName: null,
                                                    theme: null,
                                                    type: 'unstyled',
                                                    isExternal: false
                                                }
                                            ]
                                        }
                                    },
                                    {
                                        sys: {
                                            id: 'restOfItItems3'
                                        },
                                        __typename: 'Link',
                                        text: 'Nouveauté',
                                        isDisabled: true,
                                        url: '/',
                                        externalUrl: null,
                                        openLinkInNewTab: false,
                                        iconName: null,
                                        theme: null,
                                        type: 'unstyled',
                                        isExternal: false
                                    },
                                    {
                                        sys: {
                                            id: 'restOfItItems4'
                                        },
                                        __typename: 'Link',
                                        text: 'Meilleurs vendeurs',
                                        isDisabled: true,
                                        url: '/',
                                        externalUrl: '/',
                                        openLinkInNewTab: false,
                                        iconName: null,
                                        theme: null,
                                        type: 'unstyled',
                                        isExternal: false
                                    }
                                ]
                            }
                        },
                        {
                            sys: {
                                id: '5DLddapvHfrI9EVOxVDH0U'
                            },
                            __typename: 'Link',
                            text: 'Sphère',
                            url: '/pages/blogs',
                            externalUrl: null,
                            openLinkInNewTab: false,
                            iconName: null,
                            theme: null,
                            type: 'tertiary',
                            isExternal: false
                        },
                        {
                            sys: {
                                id: 'aboutLinkHeader'
                            },
                            __typename: 'Link',
                            text: 'À propos',
                            url: '/pages/about',
                            externalUrl: null,
                            openLinkInNewTab: false,
                            iconName: null,
                            theme: null,
                            type: 'tertiary',
                            isExternal: false
                        }
                    ]
                }
            }
        ]
    }
}
